// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 632) return "content/plugin-dynamic-chart-set/996a3a14ea2b5ce1e49e57c366d92153.js";
	if (chunkId === 219) return "content/plugin-dynamic-chart-set/2bb42072e43fe71001924e7f0d058020.js";
	// return url for filenames based on template
	return undefined;
};